// extracted by mini-css-extract-plugin
export var alignCenter = "_aw-d";
export var bannerShown = "_aw-6";
export var buttonContent = "_aw-0";
export var cardList = "_aw-1";
export var centerContent = "_aw-2";
export var chevron = "_aw-3";
export var closePanelButton = "_aw-k";
export var conversationContextContainer = "_aw-l";
export var conversationDetailContainer = "_aw-4";
export var detailWrapper = "_aw-7";
export var dropdownButton = "_aw-e";
export var dropdownTitle = "_aw-9";
export var fullHeight = "_aw-5";
export var hidden = "_aw-a";
export var icon = "_aw-b";
export var mergeSuggestionWrapper = "_aw-m";
export var panel = "_aw-i";
export var portalButtonsWrapper = "_aw-c";
export var right = "_aw-j";
export var tableSummaryContainer = "_aw-8";
export var tableSummaryHeader = "_aw-g";
export var threeDotsButton = "_aw-f";
export var wide = "_aw-h";